// Indigo & Co. — theme interactions
(function(){
  // Cart drawer
  var bagBtn = document.getElementById('bagBtn');
  var closeBag = document.getElementById('closeBag');
  var overlay = document.getElementById('overlay');
  var drawer = document.getElementById('drawer');

  function openDrawer(){
    if(drawer){ drawer.classList.add('open'); }
    if(overlay){ overlay.classList.add('open'); }
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(){
    if(drawer){ drawer.classList.remove('open'); }
    if(overlay){ overlay.classList.remove('open'); }
    document.body.style.overflow = '';
  }
  if(bagBtn){ bagBtn.addEventListener('click', openDrawer); }
  if(closeBag){ closeBag.addEventListener('click', closeDrawer); }
  if(overlay){ overlay.addEventListener('click', closeDrawer); }

  // Newsletter subscribe (front-end placeholder)
  var forms = document.querySelectorAll('.news-form');
  forms.forEach(function(f){
    f.addEventListener('submit', function(e){
      e.preventDefault();
      var i = f.querySelector('input');
      if(i){ i.value = ''; }
      var note = f.parentElement.querySelector('.note');
      if(note){ note.textContent = 'Welcome — you are on the list.'; }
    });
  });

  // Quick add to cart
  document.querySelectorAll('[data-quick-add]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-quick-add');
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        btn.textContent = 'Added';
        return fetch('/cart.js').then(function(r){ return r.json(); });
      })
      .then(function(cart){
        var c = document.getElementById('bagCount');
        if(c){ c.textContent = cart.item_count; }
        setTimeout(openDrawer, 250);
        setTimeout(function(){ btn.textContent = 'Quick add'; btn.disabled = false; }, 1500);
      })
      .catch(function(){
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
    });
  });

  // Search icon
  var searchBtn = document.querySelector('.nav-icons button[aria-label="Search"]');
  if(searchBtn){
    searchBtn.addEventListener('click', function(){ location.href = '/search'; });
  }

  // Mobile menu
  var navToggle = document.getElementById('navToggle');
  var mobileMenu = document.getElementById('mobileMenu');
  function closeMenu(){
    if(navToggle){ navToggle.classList.remove('open'); navToggle.setAttribute('aria-expanded','false'); }
    if(mobileMenu){ mobileMenu.classList.remove('open'); }
  }
  if(navToggle && mobileMenu){
    navToggle.addEventListener('click', function(e){
      e.stopPropagation();
      var open = mobileMenu.classList.toggle('open');
      navToggle.classList.toggle('open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mobileMenu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', closeMenu);
    });
    document.addEventListener('click', function(e){
      if(mobileMenu.classList.contains('open') && !mobileMenu.contains(e.target) && e.target !== navToggle){
        closeMenu();
      }
    });
    window.addEventListener('resize', function(){
      if(window.innerWidth > 768){ closeMenu(); }
    });
  }
})();
